module.exports = __webpack_public_path__ + "img/zhang.1c25c976.png";